import { rem } from "polished";
import styled from "styled-components";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { ColorLabels } from "@/components/editor/utils/use-color";

import { CARD_HORIZONTAL_GAP, CARD_VERTICAL_GAP } from "../constants";

export const Wrapper = withViewportStyle("div")`
  background-color: ${({ theme }) => theme.colors[ColorLabels.VISUALS]};
  margin: 0 ${rem(CARD_HORIZONTAL_GAP)} ${rem(CARD_VERTICAL_GAP)};
  width: ${rem(388)};
  overflow: hidden;

  ${(props) => props.$viewport.mobile`
    width: 100%;
    margin-left: 0;
    margin-right: 0;
  `}
`;

export const ContentWrapper = styled.div`
  padding: ${rem(24)};
  background-color: ${({ theme }) => theme.colors[ColorLabels.VISUALS]};
  position: relative;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: ${rem(8)};
`;

export const Logo = styled.img`
  height: ${rem(32)};
  width: ${rem(32)};
  object-fit: cover;
  margin-right: ${rem(8)};
`;

export const Heading = withViewportStyle("h4")`
  font-family: ${({ theme }) =>
    theme.fontImports[0]?.font?.name ?? theme.fonts[0].value};
  font-size: ${rem(20)}; 
  line-height: ${rem(32)}; 
  font-weight: 500;
  color: ${({ theme }) => theme.colors[ColorLabels.PRIMARY_FONT]};

  ${(props) => props.$viewport.tablet`
    font-size: ${rem(19)};
    line-height: ${rem(29)};
  `}

  ${(props) => props.$viewport.mobile`
    font-size: ${rem(18)};
    line-height: ${rem(26)};
  `}
`;

export const Description = withViewportStyle("p")`
  font-family: ${({ theme }) =>
    theme.fontImports[0]?.font?.name ?? theme.fonts[0].value};
  font-size: ${rem(14)}; 
  line-height: ${rem(26)}; 
  font-weight: 300;
  color: ${({ theme }) => theme.colors[ColorLabels.SECONDARY_FONT]};

  ${(props) => props.$viewport.tablet`
    font-size: ${rem(13)};
    line-height: ${rem(23)};
  `}

  ${(props) => props.$viewport.mobile`
    font-size: ${rem(12)};
    line-height: ${rem(20)};
  `}
`;
